<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        title="掲載求人の設定／解除"
      />
      <div class="grid-x align-justify margin-bottom-1">
        <div
          class="medium-6 cell"
          data-test="interview-countermeasure-name"
        >
          面接情報ページ名：{{ interview.name }}
        </div>
      </div>
      <h3 class="boss-joboffer-title boss-setting">
        面接情報を設定する求人を選択
      </h3>
      <div class="grid-x align-justify">
        <p class="boss-text boss-annotation-text">
          ※専用応募フォームを設定している求人は、面接情報は掲出できません
        </p>
      </div>
      <table
        class="unstriped boss-table"
      >
        <thead>
          <tr>
            <th class="boss-table-head-center">
              選択
            </th>
            <th class="boss-table-head-center">
              管理用求人名
            </th>
            <th class="boss-table-head-center">
              掲載期間
            </th>
            <th class="boss-table-head-center">
              ステータス
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="jobs.length">
            <tr
              v-for="(job, i) in jobs"
              :key="i"
            >
              <td
                class="boss-center text-center"
              >
                <input
                  :data-test="`job-checkbox-${i}`"
                  type="checkbox"
                  class="boss-input-checkbox"
                  :disabled="isDisabledCheckbox(job)"
                  :checked="job.isSelected"
                  @change="job.isSelected = !job.isSelected;"
                >
              </td>
              <td
                class="boss-table-data"
                :data-test="`job-name-${i}`"
              >
                {{ job.jobName }}
              </td>
              <td
                class="boss-table-data text-center"
                :data-test="`job-period-${i}`"
              >
                {{ job | periodLabel }}
              </td>
              <td
                class="boss-table-data"
                :data-test="`job-status-${i}`"
              >
                {{ job | statusLabel }}
              </td>
            </tr>
          </template>
          <tr v-else>
            <td
              colspan="4"
              data-test="no-jobs"
            >
              ※現在掲載中の求人はありません
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pega-flex-center">
        <button
          class="boss-button boss-exe-button pega-button pega-mr-5 pega-bulk-button"
          data-test="return-button"
          @click="returnInterviewTop()"
        >
          一覧に戻る
        </button>
        <button
          class="boss-button boss-exe-button pega-button pega-mr-5 pega-bulk-button"
          data-test="register-button"
          @click="updateJobInterviewCountermeasures()"
        >
          保存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import _ from 'lodash'

export default {
  filters: {
    periodLabel (val) {
      return !_.isEmpty(val) ? `${val.startDate} ～ ${val.endDate}` : ''
    },
    statusLabel (val) {
      if (val.hasExclusiveFormJob) return '専用応募フォーム有り'
      if (val.isSelectedOther) return '他面接情報ページ設定済み'
      return ''
    }
  },
  components: {
    SettingHeader
  },
  data () {
    return {
      jobs: [],
      interview: {}
    }
  },
  computed: {
    selectedJobIds () {
      return this.jobs.filter(job => job.isSelected).map(job => job.jobId)
    }
  },
  created () {
    this.fetchInterviewCountermeasures()
    this.fetchJobInterviewCountermeasures()
  },
  methods: {
    fetchJobInterviewCountermeasures () {
      this.$http.secured.get(`/jobs/_interview_countermeasures/${this.$route.params.interviewCountermeasureId}`).then(response => this.$set(this, 'jobs', response.data))
    },
    fetchInterviewCountermeasures () {
      this.$http.secured.get(`/interview_countermeasures/${this.$route.params.interviewCountermeasureId}`).then(response => this.$set(this, 'interview', response.data))
    },
    isDisabledCheckbox (job) {
      return job.isSelectedOther || job.hasExclusiveFormJob
    },
    returnInterviewTop () {
      this.$router.push({ name: 'interviewTop' })
    },
    updateJobInterviewCountermeasures () {
      this.$http.secured.put(`/jobs/_interview_countermeasures/${this.$route.params.interviewCountermeasureId}`, this.selectedJobIds).then(response => {
        this.$toasted.global.success({ message: '掲載求人を設定しました。' })
        this.returnInterviewTop()
      })
    }
  }
}
</script>
